<hr aria-hidden="true" {{#if class}}class="{{class}}"{{/if}}>